import script from "./common-rate.vue?vue&type=script&setup=true&lang=js"
export * from "./common-rate.vue?vue&type=script&setup=true&lang=js"

import "./common-rate.vue?vue&type=style&index=0&id=419c8ee6&lang=less"

const __exports__ = script;

export default __exports__